/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'cloud-connector-user-item';
const prefix = `${moduleName}.${componentName}`;

export const userCredentialsLabel = `${prefix}.userCredentialsLabel`;

export const ENGLISH = {
    [userCredentialsLabel]: 'User Credentials',
};
